<template>
  <section class="notifications_page">
    <v-container>
      <div class="__bread mt-5">
        <v-breadcrumbs :items="Bread"></v-breadcrumbs>
      </div>
      <notifications />
    </v-container>
  </section>
</template>

<script>
import notifications from "@/components/notifications/index.vue";
export default {
  components: {
    notifications,
  },
  data(){
    
    return{
      Bread: [
        {
          text: this.$t("Breadcrumb.home"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("footer.notifications"),
          disabled: true,
          to: "",
        },
      ],
    }
  },
};
</script>

<style lang="scss" scoped>

.__bread {
    box-shadow: none !important;
    margin-bottom: 36px;
    .v-breadcrumbs {
      background: #ffffff 0 0 no-repeat padding-box;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      font-size: 14px;
      box-shadow: none !important;
      padding: 12px;
    }
    .v-breadcrumbs__item {
      color: #000 !important;
    }
    .v-breadcrumbs__item--disabled {
      color: #868e96 !important;
    }
  }
.notifications_page {
  background: #fafafa;
  padding: 0 0 30px 0;
  height: 100%;
}
</style>
